import React from "react";
import { createBrowserRouter } from "react-router-dom";

import MainLayout from "../layouts/MainLayouts";
import Homepage from "../pages/Homepage/HomePage";
import NotFound from "../pages/NotFound/NotFound";
import ServicePage from "../pages/Services/Services";
import WebService from "../pages/Services/WebDev";
import MobilService from "../pages/Services/MobilDev";
import MarketingService from "../pages/Services/Marketing";
import DesignService from "../pages/Services/Design";
import ContactPage from "../pages/contact/ContactPage";
import Apropos from "../pages/APROPOS/APropos";
import FinanceSolution from "../pages/NosSolutions/FinanceSolution";
import EducationSolution from "../pages/NosSolutions/EducationSolution";
import CivilEngeneering from "../pages/Services/Civil";
import SocialVision from "../pages/Services/Social";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <MainLayout>
        <Homepage />
      </MainLayout>
    ),
  },
  {
    path: "/acceuil",
    element: (
      <MainLayout>
        <Homepage />
      </MainLayout>
    ),
  },

  {
    path: "/contact",
    element: (
      <MainLayout>
        <ContactPage />
      </MainLayout>
    ),
  },

  {
    path: "/services",
    element: (
      <MainLayout>
        <ServicePage />
      </MainLayout>
    ),
  },
  {
    path: "/apropos",
    element: (
      <MainLayout>
        <Apropos />
      </MainLayout>
    ),
  },
  {
    path: "/vision/immobilier",
    element: (
      <MainLayout>
        <WebService />
      </MainLayout>
    ),
  },

  {
    path: "/vision/informatique",
    element: (
      <MainLayout>
        <MobilService />
      </MainLayout>
    ),
  },
  {
    path: "/vision/évènementiel",
    element: (
      <MainLayout>
        <MarketingService />
      </MainLayout>
    ),
  },
  {
    path: "/vision/telecom",
    element: (
      <MainLayout>
        <DesignService />
      </MainLayout>
    ),
  },

  {
    path: "/solutions/mobile",
    element: (
      <MainLayout>
        <FinanceSolution />
      </MainLayout>
    ),
  },
  {
    path: "/solutions/web",
    element: (
      <MainLayout>
        <EducationSolution />
      </MainLayout>
    ),
  },
  {
    path: "/vision/civilEngeneering",
    element: (
      <MainLayout>
      <CivilEngeneering />
      </MainLayout>
    ),
  },
  {
    path: "/vision/socialPlatform",
    element: (
      <MainLayout>
        <SocialVision />
      </MainLayout>
    ),
  },

  {
    path: "*",
    element: <NotFound />,
  },
]);

export default router;
